import $ from 'jquery'
import {scNamespace} from "./scNamespace"
import 'jquery.easing'
import Localstore from "./localstore/localStorage"
import Is from 'is_js'
import Moment from 'moment'

const scrollEvent = 'mousewheel'
const mobileTouchStart = 'touchstart'
const mobileToucMove = 'touchmove'
const mobileTouchEnd = 'touchend'

let $body = $('body')
let toWindowByWheel = function (e) {
  let currentDelta = e.originalEvent.deltaY

  if(window.$VueInstance.GLOBAL.windowScrolling) {
    return
  }

  if(Math.abs(currentDelta) <= 10) {
    return
  }

  window.$VueInstance.GLOBAL.windowScrolling = true
  let nextPageOffset = 1
  if(currentDelta < 0) {
    nextPageOffset = -1
  }

  toWindowByIdx.call(window.$VueInstance, window.$VueInstance.GLOBAL.currentWindow + nextPageOffset)
}

let swipeStartY = 0
let swipeStartTime = 0
let swipeLastY = 0
let swipeStart = function (e) {
  swipeStartY = e.originalEvent.touches[0].pageY
  swipeLastY = swipeStartY
  swipeStartTime = new Moment()
}

let swiping = function (e) {
  e.preventDefault()
  swipeLastY = e.originalEvent.touches[0].pageY
}

let swipeEnd = function (e) {
  let endTime = new Moment()
  let duration = Moment.duration(endTime.diff(swipeStartTime))
  let distance = swipeLastY - swipeStartY
  if(duration > 200) {
    return
  }

  if(Math.abs(distance) < 50) {
    return
  }

  let nextPageOffset = 1
  window.$VueInstance.GLOBAL.windowScrolling = true
  if(distance > 0) {
    nextPageOffset = -1
  }
  toWindowByIdx.call(window.$VueInstance, window.$VueInstance.GLOBAL.currentWindow + nextPageOffset)
}

let resetWheelScrollListener = function () {
  if(Is.mobile()) {
    $body.off(mobileTouchStart).on(mobileTouchStart, swipeStart)
    $body.off(mobileToucMove).on(mobileToucMove, swiping)
    $body.off(mobileTouchEnd).on(mobileTouchEnd, swipeEnd)
  } else {
    $body.off(scrollEvent).on(scrollEvent, toWindowByWheel)
  }
}

let toWindowByIdx = function (idx) {
  let page = scNamespace.PAGE.ORDERED[idx]
  if(!page) {
    window.$VueInstance.GLOBAL.windowScrolling = false
    return
  }

  toPage.call(this, page.uri)
}

let visibilityChanged = function(isVisible) {
  isVisible ? this.showPage() : this.hidePage()
}

let showPage = function (pageID) {
  pageID = pageID || this.pageID
  if(!pageID) {
    return
  }

  let $target = $(`#${pageID}`)

  let $allAnimatedEl = $target.find('.will-animate')

  $allAnimatedEl.each((idx, el)=> {
    let $el = $(el)
    $el.removeClass($el.data('ani'))
  })

  $allAnimatedEl.each((idx, el)=> {
    let $el = $(el)
    $el.addClass($el.data('ani'))
  })

}

let hidePage = function (pageID) {
  pageID = pageID || this.pageID
  if(!pageID) {
    return
  }

  let $target = $(`#${pageID}`)

  let $allAnimatedEl = $target.find('.will-animate')

  $allAnimatedEl.each((idx, el)=> {
    let $el = $(el)
    $el.removeClass($el.data('ani'))
  })
}

let resizeContentWindow = function () {
  $('#app.invisible').removeClass('invisible')
  let minHeight = $(window).outerHeight() - 96
  if(Is.mobile()) {
    minHeight = $(window).outerHeight()
  }

  $('.content-window-container').each((idx, el)=>{
    let $el = $(el)
    let elHeight = $el.outerHeight()

    let elPadding = Math.abs((minHeight - elHeight) / 2)

    let pageId = $(el).attr('id')

    if('sc-page-home' !== pageId) {
      if(elPadding > 200 && ('sc-page-roadmap' !== pageId)) {
        elPadding = 200
      } else if($(window).width() <= 720){
        if('sc-page-service' === pageId ||
          'sc-page-technology' === pageId ||
          'sc-page-roadmap' === pageId ||
          'sc-page-team' === pageId) {
          elPadding = 40
        }
      }
    }

    $el.css({
      paddingTop: elPadding,
      paddingBottom: elPadding,
    })
  })
}

let setWindowIdx = function (id) {
  let pageCount = scNamespace.PAGE.ORDERED.length
  for(let i=0; i<pageCount; i++) {
    if(id === scNamespace.PAGE.ORDERED[i].id) {
      this.GLOBAL.currentWindow = i
      break
    }
  }
}

let pageMounted = function () {
  setWindowIdx.call(this, this.pageID)
  if(Is.function(this.localMounted)) {
    this.localMounted()
  }
}

let toPage = function(id, lang) {
  let topOffset = 96
  if(Is.mobile()) {
    topOffset = 42
  }


  $('html, body').animate({scrollTop: $(`#${id}`).offset().top - topOffset}, 500)
}

let changeLang = function (lang) {
  window.$I18n.locale = lang
  Localstore.SetLang(lang)
}

let lang = function () {
  return 'zh' === window.$I18n.locale ? 'ZH' : 'EN';
}

function mustSlideCommonContent() {
  return $(window).width() <= 720
}

let basicPageMethods = function () {
  return {
    showPage: showPage,
    hidePage: hidePage,
    toPage: toPage,
    lang: lang,
    visibilityChanged: visibilityChanged,
  }

}

export {
  toWindowByIdx,
  changeLang,

  lang,
  showPage,
  hidePage,
  visibilityChanged,

  pageMounted,
  toPage,
  resizeContentWindow,
  mustSlideCommonContent,

  basicPageMethods,
}